import { render, staticRenderFns } from "./AppChange.vue?vue&type=template&id=08e5142c"
import script from "./AppChange.vue?vue&type=script&lang=js"
export * from "./AppChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports